import { ChangeDetectionStrategy, Component, HostListener, OnInit, Renderer2, inject } from '@angular/core';
import { Router } from '@angular/router';

interface MenuItemInstitucional {
  label: string;
  icon?: string;
  route?: string;
  exact?: boolean;
  expanded?: boolean;
  disabled?: boolean;
  children?: MenuItemInstitucional[];
}

type ModoSidebarInstitucional = 'mobile' | 'tablet' | 'desktop';

const LARGURA_TABLET = 768;
const LARGURA_DESKTOP = 1024;

@Component({
  selector: 'app-institucional-sidebar',
  standalone: false,
  templateUrl: './institucional-sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../main-layout/main-sidebar/main-sidebar.component.css'
})
export class InstitucionalSidebarComponent implements OnInit {
  private readonly renderer = inject(Renderer2);
  private readonly router = inject(Router);

  modo: ModoSidebarInstitucional = 'desktop';

  isCollapsed = false;

  private desktopAberto = true;

  menuItems: MenuItemInstitucional[] = [
    {
      label: 'Gerenciador de Módulos',
      icon: 'book-open',
      route: '/institucional/modulos'
    }
  ];

  ngOnInit(): void {
    this.atualizarLayout();
  }

  get podeAlternar(): boolean {
    return this.modo === 'desktop';
  }

  get exibirRotulos(): boolean {
    return this.modo === 'desktop' && !this.isCollapsed;
  }

  get exibirRotulosSubmenu(): boolean {
    return this.modo === 'mobile' || this.exibirRotulos;
  }

  @HostListener('window:resize')
  atualizarLayout(): void {
    const largura = window.innerWidth;

    this.modo = largura < LARGURA_TABLET
      ? 'mobile'
      : largura < LARGURA_DESKTOP
        ? 'tablet'
        : 'desktop';

    this.isCollapsed = this.modo === 'desktop' ? !this.desktopAberto : true;
    this.aplicarClassesDoCorpo();
  }

  alternarSidebar(): void {
    if (!this.podeAlternar) {
      return;
    }

    this.isCollapsed = !this.isCollapsed;
    this.desktopAberto = !this.isCollapsed;
    this.aplicarClassesDoCorpo();
  }

  alternarItem(item: MenuItemInstitucional): void {
    if (!item.children?.length) {
      return;
    }

    item.expanded = !item.expanded;
  }

  itemAtivo(item: MenuItemInstitucional): boolean {
    const url = this.router.url.split('?')[0];

    if (item.route) {
      const rotaAtiva = item.exact ? url === item.route : url.startsWith(item.route);
      if (rotaAtiva) {
        return true;
      }
    }

    return item.children?.some((filho) => this.itemAtivo(filho)) ?? false;
  }

  private aplicarClassesDoCorpo(): void {
    const mobile = this.modo === 'mobile';
    const recolhido = !mobile && this.isCollapsed;

    if (mobile) {
      this.renderer.addClass(document.body, 'sidebar-mobile');
    } else {
      this.renderer.removeClass(document.body, 'sidebar-mobile');
    }

    if (recolhido) {
      this.renderer.addClass(document.body, 'sidebar-collapsed');
    } else {
      this.renderer.removeClass(document.body, 'sidebar-collapsed');
    }
  }
}
